"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image = void 0;

var react_1 = __importDefault(require("react"));

var caption_1 = require("../typography/caption");

var Image = function Image(_a) {
  var src = _a.src,
      alt = _a.alt,
      caption = _a.caption,
      theme = _a.theme;
  return react_1["default"].createElement("figure", {
    className: "flex flex-col w-full " + (theme ? theme.body.backgroundColor : 'bg-gray-100')
  }, react_1["default"].createElement("img", {
    src: src,
    alt: alt,
    className: "rounded-md md:rounded-lg mb-4 md:mb-6"
  }), caption && react_1["default"].createElement(caption_1.Caption, {
    theme: theme
  }, caption));
};

exports.Image = Image;